<template>
  <div class="uploadFile-box">
    <div v-if="!disabled" class="tips">
      <slot></slot>
    </div>
    <el-upload
      list-type="picture-card"
      v-if="!disabled && (!limit || fileList.length < limit)"
      class="upload-file-form"
      ref="uploadFile"
      drag
      multiple
      :limit="limit"
      :headers="header"
      :action="uploadUrl + action"
      :accept="accept"
      :on-success="handleFileSuccess"
      :before-upload="beforeFileUpload"
      :on-progress="handleProgress"
      :on-exceed="handleExceed"
      :on-error="handleFileError"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <div class="file-item" v-for="(file, index) in fileList" :key="index">
      <el-image
        v-if="updateView"
        class="file-img"
        :src="getOssImgUrl(file)"
        fit="cover"
      />
      <span class="upload-action">
        <span @click="viewFile(file)">
          <i class="el-icon-zoom-in"></i>
        </span>
        <span @click="downLoad(file)">
          <i class="el-icon-download"></i>
        </span>
        <span v-if="!disabled" @click="handleRemoveFile(file)">
          <i class="el-icon-delete"></i>
        </span>
      </span>
    </div>
    <div v-if="disabled && (!fileList || fileList.length === 0)">无</div>
    <div v-for="file in fileListIng" :key="file.uid" class="file-list">
      <div style="width: 250px; position: relative;">
        <div class="file-name-box">
          <i
            class="el-icon-document"
            style="margin-right: 7px; color: #909399"
          ></i>
          <span class="file-name">{{ file.name }}</span>
        </div>
        <el-progress class="progress" :percentage="file.progress"></el-progress>
      </div>
    </div>
    <view-img-video ref="viewRef" />
  </div>
</template>

<script>
import { totalSum } from "@/util/totalSum";
import { uploadUrl } from "@/util/url";
import ViewImgVideo from "@/components/viewImgVideo.vue";

export default {
  name: "file-upload2",
  components: { ViewImgVideo },
  model: {
    prop: "fileList",
    event: "c-change"
  },
  props: {
    // 上传文件数组
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 上传地址
    action: {
      type: String,
      default: ""
    },
    accept: {
      type: String,
      default: ".jpg,.png,.jpeg"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      uploadUrl,
      uploading: false, // 上传状态
      updateView: true,
      header: {
        satoken: sessionStorage.getItem("token")
      }, // 上传
      fileListIng: []
    };
  },
  methods: {
    // 文件数量超出限制
    handleExceed(files, fileList) {
      this.$DonMessage.warning(`一次性上传图片不能超过${this.limit}张，当前选择了${files.length + fileList.length}张图片`);
    },
    // 上传错误
    handleFileError(err, file, fileList) {
      // 从正在上传列表中移除该文件
      this.fileListIng.splice(
        this.fileListIng.findIndex(item => {
          return item.uid === file.uid;
        }),
        1
      );
      this.$DonMessage.error("文件上传失败");
    },
    // 上传进度
    handleProgress(event, file, fileList) {
      const index = this.fileListIng.findIndex(item => {
        return item.uid === file.uid;
      });
      if (index != -1) {
        this.fileListIng[index].progress = parseInt(event.percent);
      }
    },
    // 删除上传文件
    handleRemoveFile(file) {
      this.fileList.map((item, index) => {
        if (item == file) {
          this.fileList.splice(index, 1);
          this.updateView = false;
          this.$nextTick(() => {
            this.updateView = true;
          });
        }
      });
      this.$emit("delChange", file);
      this.$emit("c-change", this.fileList);
    },
    // 上传之前
    beforeFileUpload(file) {
      // 检查数量限制（已上传的文件 + 正在上传的文件 + 当前文件）
      if (this.limit && (this.fileList.length + this.fileListIng.length) >= this.limit) {
        this.$DonMessage.warning(`一次性上传图片不能超过${this.limit}张`);
        return false;
      }

      this.fileListIng.push({
        uid: file.uid,
        name: file.name,
        progress: 0
      });
      this.uploading = true;
      // 限制文件大小
      const imgLt = 500;
      let limit = 0;
      let isLt = 0;
      // 图片
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSvg = file.type === "image/svg+xml";
      let isImg = false;
      if (isJPG || isPNG || isSvg) {
        isImg = true;
      }
      if (isImg) {
        limit = imgLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.uploading = false;
          // 从正在上传列表中移除该文件
          this.fileListIng.splice(
            this.fileListIng.findIndex(item => {
              return item.uid === file.uid;
            }),
            1
          );
          this.$DonMessage.warning("上传图片大小不能超过 500MB!");
        }
        return isImg && isLt;
      }
    },
    // 上传成功
    handleFileSuccess(res, file) {
      this.fileListIng.splice(
        this.fileListIng.findIndex(item => {
          return item.uid === file.uid;
        }),
        1
      );
      if (res.status == 0) {
        let data = res.data;
        this.fileList?.push(data.filePath);
        this.$emit("c-change", this.fileList);
      } else {
        this.$DonMessage.error(res.message);
        let uid = file.uid; // 关键作用代码，去除文件列表失败文件
        let idx = this.$refs.uploadFile.uploadFiles.findIndex(
          item => item.uid === uid
        );
        this.$refs.uploadFile.uploadFiles.splice(idx, 1);
      }
    },
    // 下载
    downLoad(filePath) {
      window.open(filePath);
    },
    // 预览
    viewFile(file) {
      this.$refs.viewRef.init({ filePath: file, fileType: "img" });
    },
    getOssImgUrl(file) {
      return `${file}?x-oss-process=image/resize,w_424`;
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-file-form {
  display: inline-block;
  ::v-deep .el-upload {
    vertical-align: unset;
    margin-right: 20px;
  }
  ::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
}

.file-item {
  display: inline-block;
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 20px;
  .file-img {
    width: 100%;
    height: 100%;
  }
  .type-icon {
    position: absolute;
    top: 8px;
    left: 8px;
    line-height: 0;
    font-size: 20px;
    color: #fff;
    background: #747474;
  }
  .upload-action {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
  }
  .upload-action:hover {
    opacity: 1;
  }
  .upload-action span {
    cursor: pointer;
  }
  .upload-action span + span {
    margin-left: 15px;
  }
}

::v-deep .el-upload-list {
  display: none;
}
.tips {
  // margin-top: -20px;
  line-height: 20px;
  color: #cecece;
  font-size: 12px;
}
.file-name-box {
  overflow: hidden; /* 确保超出容器的文本被隐藏 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
  margin-right: 50px;
}
.progress {
  position: absolute;
  top: 22px;
  width: 100%;
  ::v-deep {
    .el-progress-bar {
      margin-right: 0;
      padding-right: 0;
    }
    .el-progress__text {
      position: absolute;
      right: 0;
      top: -10px;
    }
    .el-progress-bar__outer {
      height: 2px !important;
    }
  }
}
::v-deep .el-upload-dragger {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss">
.is-error {
  .upload-file-form {
    .el-upload-dragger {
      border-color: #f56c6c;
    }
  }
}
</style>
